
<template>
    <Section class="layout-8-12">
        <Content>
            <h2>Is this what you were looking for?</h2>
            <p>Based on your search, we suspect these are 3 the most relevant results to your search query.</p>
            <CardResource
                v-for="result in mostRelevantResults"
                :key="`relevant-${result.id}`"
                v-bind="result"
                :isSearch="true"
                :showArea="true"
                :showAllMeta="true"
            />
        </Content>
    </Section>
</template>

<script>
export default {
    props: {
        mostRelevantResults: {
            type: Array,
            required: true
        }
    }
}
</script>

